module.exports = require("clean-webpack-plugin");